






























import Vue from "vue";

interface Data {
  buttons: {
    icon: string;
    label: string;
    path: string;
    separator?: boolean;
  }[];
}

export default Vue.extend({
  name: "c-sidebar",
  props: {
    open: {
      type: Boolean
    }
  },

  data(): Data {
    return {
      buttons: [
        {
          icon: "home",
          label: "Home",
          path: "/"
        },
        {
          icon: "people",
          label: "Lista clienti",
          path: "/customers"
        },
        {
          icon: "pivot_table_chart",
          label: "Storico compliance",
          path: "/customers-consents"
        },
        {
          icon: "file_download",
          label: "Confronto dati anima",
          path: "/send-anima-compare"
        }
      ]
    };
  }
});
